<template>
  <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="3"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <div class="d-form">
          <h3 class="h-title">修改密码</h3>
          <div class="f-b">
            <el-form ref="form" :rules="rules" style="width: 600px; margin: 0 auto" :model="form" label-position="left" label-width="140px" class="reg-form" >
              <el-form-item label="请输入原密码" prop="oldPwd"> 
                  <el-input type="password" v-model.trim="form.oldPwd" placeholder="请输入原密码" /> 
              </el-form-item> 
              <el-form-item label="请输入新密码" prop="newPwd"> 
                <el-input type="password" v-model.trim="form.newPwd" :minlength="6" :maxlength="18"  placeholder="请输入新密码" />  
              </el-form-item> 
              <el-form-item label="请再次输入新密码" prop="rePwd"> 
                  <el-input type="password" v-model.trim="form.rePwd" placeholder="请再次输入新密码" /> 
              </el-form-item> 
              <div class="cenrer">		
                <el-button class="s-but" type="orange" @click.native="handlePwd">提交</el-button>
              </div>
            </el-form> 

          </div>
        </div>
      </el-main>
  </el-container>
</template>

<script>
import leftMenu from './components/leftMenu'
import { encryptedData } from '@/utils/jsencrypt'
export default {
  name: "changePwd",
  components: {
    leftMenu
  },
  data() {
    return {
      form: {},
      rules: {
        oldPwd: [
          { required: true, trigger: "blur", message: "密码不能为空" }
        ],
        newPwd : [
          {
            pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[#@!~%^&*.])[a-zA-Z\d#@!~%^&*.]{6,18}$/,
            message: "密码包含字母、数字及特殊字符的6-18位",
            trigger: "blur"
          },
          { required: true, trigger: "blur", message: "密码不能为空" }
        ],
        rePwd: [
          { required: true, trigger: "blur", message: "密码不能为空" }
        ]
      },
    }
  },
  created() {
    
  },
  methods: {
    handlePwd(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.newPwd !== this.form.rePwd) {
            this.$message.error('两次输入密码不同！');
            return;
          }  
          let param = {
            oldPassword: encryptedData(this.form.oldPwd),
            newPassword: encryptedData(this.form.newPwd),
            username: sessionStorage.account
          }
          this.$api.api.changeOrganPassword(param).then(res => {
            if(res.code == 200){
              this.$message.success("密码修改成功！")
            }else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
@import '../style.less';
</style>
